import { render, staticRenderFns } from "./MaterialCost.vue?vue&type=template&id=2d74d55a&scoped=true&"
import script from "./MaterialCost.vue?vue&type=script&lang=js&"
export * from "./MaterialCost.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCost.vue?vue&type=style&index=0&id=2d74d55a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d74d55a",
  null
  
)

export default component.exports